import { FC } from "react";

const MapPin: FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_229_1479)">
        <path
          d="M14 6.66629C14 11.333 8 15.333 8 15.333C8 15.333 2 11.333 2 6.66629C2 5.07499 2.63214 3.54887 3.75736 2.42365C4.88258 1.29843 6.4087 0.66629 8 0.66629C9.5913 0.66629 11.1174 1.29843 12.2426 2.42365C13.3679 3.54887 14 5.07499 14 6.66629Z"
          stroke="#080A25"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 8.66629C9.10457 8.66629 10 7.77086 10 6.66629C10 5.56172 9.10457 4.66629 8 4.66629C6.89543 4.66629 6 5.56172 6 6.66629C6 7.77086 6.89543 8.66629 8 8.66629Z"
          stroke="#080A25"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_229_1479">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 -0.000366211)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MapPin;
